import { atom } from "recoil";

export const isMapLoadState = atom({
  key: "isMapLoadState",
  default: false,
});

export const mapOptionsState = atom<any>({
  key: "mapOptionsState",
  default: undefined,
});
